PageApp.Views.CreateAccountActivatedView = Backbone.Marionette.ItemView.extend({
  template: hbs.templates.createAccountActivated
})
